import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "abit-radio" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-stack mb-5 cursor-pointer flex-grow-1"
}
const _hoisted_3 = { class: "d-flex align-items-center me-2" }
const _hoisted_4 = { class: "symbol symbol-50px me-6" }
const _hoisted_5 = { class: "symbol-label" }
const _hoisted_6 = { class: "svg-icon svg-icon-1 svg-icon-gray-600" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "fw-bolder text-gray-800 text-hover-primary fs-5" }
const _hoisted_9 = { class: "" }

import { useField } from "vee-validate";
import { useAttrs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitRadio',
  props: {
    name: {},
    label: {},
    placeholder: {},
    required: { type: Boolean },
    size: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emitInput = __emit;

const props = __props;

const handleChange = (newValue: string) => {
    value.value = newValue;
    emitInput("update:modelValue", newValue);
};

const attrs = useAttrs();

const { value, errorMessage } = useField<string>(props.name);

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(['form-label', props.required && 'required'])
    }, _toDisplayString(props.label), 3),
    _createVNode(_component_el_form_item, {
      error: _unref(errorMessage),
      validateStatus: _unref(errorMessage) ? 'error' : 'success'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, _mergeProps({
          "model-value": _unref(value),
          onChange: handleChange,
          name: props.name
        }, _unref(attrs), {
          class: _ctx.d - _ctx.flex
        }), {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: option.value
              }, [
                (option.icon)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
                      _createElementVNode("span", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, [
                          _createElementVNode("span", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, [
                              _createVNode(_component_inline_svg, {
                                src: `media/icons/duotune/${option.icon}.svg`
                              }, null, 8, ["src"])
                            ])
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_7, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(option.label), 1)
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_el_radio, {
                          size: props.size || 'default',
                          name: props.name,
                          label: option.value
                        }, null, 8, ["size", "name", "label"])
                      ])
                    ]))
                  : (_openBlock(), _createBlock(_component_el_radio, {
                      key: 1,
                      name: props.name,
                      label: option.value,
                      class: "show-label"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["name", "label"]))
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 16, ["model-value", "name", "class"])
      ]),
      _: 1
    }, 8, ["error", "validateStatus"])
  ]))
}
}

})